import { render, staticRenderFns } from "./ConsumptionsScreen.vue?vue&type=template&id=70ba6631&"
import script from "./ConsumptionsScreen.vue?vue&type=script&lang=ts&"
export * from "./ConsumptionsScreen.vue?vue&type=script&lang=ts&"
import style0 from "./ConsumptionsScreen.vue?vue&type=style&index=0&id=70ba6631&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports